module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/车载1.28f6f26b.png";